import { Component, PropsWithChildren, ReactNode } from "react";

import { Error500, Error500Props } from "./Error500";

type ErrorBoundaryProps = PropsWithChildren<Omit<Error500Props, "errorData">>;

type ErrorBoundaryState = {
  error: Error | null;
};

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  render(): ReactNode {
    const { showHelpLinks, children } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <Error500
          showHelpLinks={showHelpLinks}
          errorData={import.meta.env.DEV ? error : undefined}
        />
      );
    }

    return children;
  }
}
